export const NoConversation = () => {
    return (
        <div className="flex flex-1 flex-col h-full items-center justify-center bg-background-secondary">
            <p className="text-sm text-text-secondary">Select conversation to the left</p>
        </div>
    );
};

export default NoConversation;
